import React, { Component } from 'react';
import Alert from 'react-s-alert';
import { Provider } from 'react-redux';
import Routes from '../../routes';
import store from '../../store';
import Authenticate from 'react-openidconnect';
import { OidcSettings } from '../../constants';
import './style.scss';
import '@babel/polyfill';
import '../../shared/common.scss';
import 'bootstrap/dist/css/bootstrap.css';
import 'jquery/src/jquery';
import 'bootstrap/dist/js/bootstrap.min';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/flip.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-confirm-alert/src/react-confirm-alert.css';




class App extends Component {
  constructor(props) {
    super(props);
    this.userLoaded = this.userLoaded.bind(this);
    this.userUnLoaded = this.userUnLoaded.bind(this);

    this.state = { user: undefined };

  }
  userLoaded(user) {
    if (user) this.setState({ user: user });
  }

  userUnLoaded() {
    this.setState({ user: undefined });
  }

  NotAuthenticated() {
    return (
      <div className="login">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-7 col-md-7 col-sm-12 col-xs-12 welcome-box">
              <p className="welcome-text">
                Portal{' '}
                <span className="project-name">
                  Comercial <i className="fas fa-sign-in-alt" />
                </span>
              </p>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 info-box">
              <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12 logo-box">
                <img src="/img/logo-branco.png" />
              </div>
              <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12 logo-box mobile-logo">
                <img src="/img/logo-cinza.png" />
              </div>
              <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <p className="text text-center help" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {

    return (

      <Authenticate
        OidcSettings={OidcSettings}
        userLoaded={this.userLoaded}

        userunLoaded={this.userUnLoaded}
        renderNotAuthenticated={this.NotAuthenticated}
      >



        <Provider store={store}>
          <Routes />

          <Alert
            stack={{ limit: 5 }}
            html
            position={'top-right'}
            effect={'flip'}
            timeout={5000}
          />

        </Provider>
      </Authenticate>
    );
  }
}

export default App;
